if (!customElements.get('added-notification')) {
  const STACK_GAP = 10;

  const AddedNotification = class extends HTMLElement {
    connectedCallback() {
      this.setProductTitle(this.dataset.productTitle);
      this.display();
    }

    disconnectedCallback() {
      clearTimeout(this.delayedDismissTimeout);
    }

    setProductTitle(productTitle) {
      this.querySelector('.added-notification__message-title').innerText = productTitle;
    }

    display() {
      // reveal
      setTimeout(() => {
        this.classList.remove('added-notification--hidden');
        AddedNotification.restack();
      }, 10);

      // dismiss after a short period of time
      this.delayedDismissTimeout = setTimeout(this.dismiss.bind(this), 6000);

      // add events to internal links
      this.querySelector('.added-notification__close').addEventListener('click', this.dismiss.bind(this));
      if (theme.settings.cartType === 'drawer') {
        const cartLinks = this.querySelectorAll('.added-notification__message-text a[href$="/cart"]');
        cartLinks.forEach((el) => {
          el.addEventListener('click', (evt) => {
            evt.preventDefault();
            document.querySelector('.js-cart-drawer').open();
            this.dismiss();
          });
        });
      }
    }

    dismiss(evt) {
      if (evt) { evt.preventDefault(); }
      this.classList.add('added-notification--dismissed');
      AddedNotification.restack();
      setTimeout(this.remove.bind(this), 2000);
    }

    /**
     * Stacks every notification that's currently on screen, one below the
     * previous, instead of letting several pile up on the exact same spot.
     * A dismissed notification is excluded so the rest close the gap.
     */
    static restack() {
      const visible = Array.from(document.querySelectorAll('.added-notification'))
        .filter((el) => !el.classList.contains('added-notification--dismissed'));

      let offset = 0;
      visible.forEach((el) => {
        el.style.transform = offset ? `translateY(${offset}px)` : '';
        offset += el.offsetHeight + STACK_GAP;
      });
    }
  };

  window.customElements.define('added-notification', AddedNotification);
}
